import React from "react";
import { Badge } from "react-bootstrap";
import EllipsisDropdown, {
  EllipsisDropdownItem,
  EllipsisDropdownSection,
} from "../../../../../components/EllipsisDropdown";
import { dateTimeFormatter, euroFormatter } from "../../../../../global";
import { navigateTo } from "../../../../../global/navigationHelper";

const InvoiceRow = ({ invoice, stay, onPaymentEdit, onDelete }) => {
  function handleEditInvoice() {
    navigateTo(`/dashboard/stays/${stay.id}/invoices/${invoice.id}/edit`);
  }

  return (
    <tr key={invoice.id}>
      <td>
        <div>
          {invoice.booking_id ? (
            <div>
              {invoice.booking_id}-{invoice.id}
            </div>
          ) : (
            <div>{invoice.id}</div>
          )}
        </div>

        {invoice.type_of == "booking" && (
          <Badge variant={"primary"} pill text={"light"} className="mr-2">
            Buchung
          </Badge>
        )}

        {invoice.document_type === "refund" && (
          <Badge variant={"danger"} pill text={"light"} className="mr-2">
            Reso
          </Badge>
        )}

        <Badge
          variant={invoice.status === "paid" ? "success" : "warning"}
          pill
          text={"light"}
          className="mr-2"
        >
          {invoice.status === "paid" ? "Bezahlt" : "Unbezahlt"}
        </Badge>
      </td>
      <td>
        {euroFormatter(invoice.total_sum - invoice.open_amount)} /{" "}
        {euroFormatter(invoice.total_sum)}
      </td>
      <td>{euroFormatter(invoice.open_amount)}</td>
      <td>
        {invoice.fiscal_printed_at
          ? dateTimeFormatter(invoice.fiscal_printed_at)
          : "-"}
      </td>
      <td>
        <div>{invoice.formatted_payment_type}</div>
      </td>
      <td>{dateTimeFormatter(invoice.created_at)}</td>
      <td>
        <div className={"d-flex align-items-center"}>
          <EllipsisDropdown>
            <EllipsisDropdownSection>
              <EllipsisDropdownItem onClick={handleEditInvoice}>
                Bearbeiten
              </EllipsisDropdownItem>

              <EllipsisDropdownItem onClick={() => onPaymentEdit(invoice)}>
                Zahlungen bearbeiten
              </EllipsisDropdownItem>
            </EllipsisDropdownSection>
            <EllipsisDropdownSection>
              {!invoice.fiscal_printed_at && (
                <EllipsisDropdownItem onClick={() => onDelete(invoice)}>
                  Löschen
                </EllipsisDropdownItem>
              )}
            </EllipsisDropdownSection>
          </EllipsisDropdown>
        </div>
      </td>
    </tr>
  );
};

export default InvoiceRow;
